import { TransportItem, Weights, ScoredFlight } from '../types';
import { format, addDays } from 'date-fns';


export const sortByPriceAsc = (list: TransportItem[]) => {
  return [...list].sort((a, b) => a.A - b.A);
};




export const formatTime = (isoDate: string) => format(new Date(isoDate), 'HH:mm');
export const formatDate = (isoDate: string) => format(new Date(isoDate), 'dd MMM yyyy');

export const formatPrice = (price:number, currency: string) => {
    const priceDisplay = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency }).format(price);
    return priceDisplay
}

// ✅ Ajouter des jours sans modifier la date d’origine
export const addDaysToDate = (isoDate: string, numberOfDays: number): string => {
  const originalDate = new Date(isoDate);
  const newDate = addDays(originalDate, numberOfDays);
  return format(newDate, 'yyyy-MM-dd'); // ou renvoie newDate si tu veux garder le type Date
};


export const formatDateToISO = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Mois = 0-indexé
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`; // ex : "2025-08-19"
};


export function getTopOffers(
  flights: TransportItem[],
  weights: Weights = { price: 1, duration: 1, efficiency: 1 },
  nb: number = 10,
): ScoredFlight[] {
  const flightList: ScoredFlight[] = flights.map(f => ({
    ...f,
    efficiency: f.A > 0 ? f.du / f.A : Infinity,
    totalScore: 0,
    labels: []
  }));


  const addLabels = (
    items: ScoredFlight[],
    key: keyof ScoredFlight,
    label: string,
    topN = 3
  ) => {
    [...items]
      .sort((a, b) => a[key]! - b[key]!)
      .slice(0, topN)
      .forEach(item => {
        if (!item.labels.includes(label)) {
          item.labels.push(label);
        }
      });
  };

  // Rank and label by criteria
  addLabels(flightList, "A", "économique");
  addLabels(flightList, "du", "rapide");
  addLabels(flightList, "efficiency", "performant");

  // Total score
  const rankBy = (key: keyof ScoredFlight): { id: string; rank: number }[] =>
    [...flightList]
      .sort((a, b) => a[key]! - b[key]!)
      .map((f, index) => ({ id: f.id, rank: index + 1 }));

  const priceRanks = rankBy("A");
  const durationRanks = rankBy("du");
  const efficiencyRanks = rankBy("efficiency");

  flightList.forEach(flight => {
    const priceRank = priceRanks.find(r => r.id === flight.id)?.rank ?? 0;
    const durationRank = durationRanks.find(r => r.id === flight.id)?.rank ?? 0;
    const efficiencyRank = efficiencyRanks.find(r => r.id === flight.id)?.rank ?? 0;

    flight.totalScore =
      priceRank * weights.price +
      durationRank * weights.duration +
      efficiencyRank * weights.efficiency;
  });

  return flightList
    .sort((a, b) => a.totalScore - b.totalScore)
    .slice(0, nb);
}





export function normalizeString(input: string): string {
  return input.normalize("NFD") // Décompose les caractères accentués
              .replace(/[\u0300-\u036f]/g, ""); // Supprime les marques diacritiques (accents)
}

export function isFutureDate(isoDate: string) {
  const inputDate = new Date(isoDate);
  const now = new Date();


  const inputDateOnly = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
  const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  if (isNaN(inputDate.getTime())) {
    throw new Error("Date invalide");
  }

  return inputDateOnly >= nowDateOnly;
}


export async function checkImageExists(path: string): Promise<boolean> {
  try {
    const res = await fetch(path, { method: "HEAD" });
    return res.ok;
  } catch {
    return false;
  }
}